import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import cx from 'classnames';

import { Actions } from 'app/redux/ui/questions/actions';

import styles from './styles.css';

class AnswerGroup extends PureComponent {
  getIsSelectedAnswer = answerKey => {
    const { selectedAnswers } = this.props;

    const answersKeyArray = Object.keys(selectedAnswers);
    const selectedAnswerKeys = answersKeyArray.map(key => {
      return selectedAnswers[key].uniqueKey;
    });

    return selectedAnswerKeys.includes(answerKey);
  };

  handleSelectAnswer = answer => () => {
    const {
      dispatchSelectAnswer,
      questionId,
      handleOnAnswerClick,
      isLastQuestion,
    } = this.props;

    const payload = {
      [questionId]: {
        ...answer,
      },
    };

    if (isLastQuestion) {
      dispatchSelectAnswer(payload);
    } else {
      setTimeout(() => {
        dispatchSelectAnswer(payload);
        handleOnAnswerClick();
      }, 150);
    }
  };

  renderAnswerList = answer => {
    const isSelectedAnswer = this.getIsSelectedAnswer(answer.uniqueKey);

    const buttonClasses = cx({
      [styles.button]: true,
      [styles.buttonIsSelectd]: isSelectedAnswer,
    });

    return (
      <li className={styles.answerContainer} key={answer.uniqueKey}>
        <button
          className={buttonClasses}
          onClick={this.handleSelectAnswer(answer)}
        >
          {answer.answer}
        </button>
      </li>
    );
  };

  render() {
    const { answers } = this.props;

    return (
      <ul className={styles.container}>{answers.map(this.renderAnswerList)}</ul>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  dispatchSelectAnswer: (answer, questionId) =>
    dispatch(Actions.selectAnswer(answer, questionId)),
});

export default connect(
  null,
  mapDispatchToProps
)(AnswerGroup);



// WEBPACK FOOTER //
// ./src/components/AnswerGroup/index.js